import Alpine from 'alpinejs';
import { initLocationPage } from './location-page';
import { initEmployeesFilters } from './employees-page';
import Splide from '@splidejs/splide';
import './search-cars';
import './components/remove-filter';
import './components/auto-submit';
import './components/cuf-off';
import './components/car-carousel';
import './components/flex-slider.js';
import './components/format-money.js';
import './components/car-image-carousel';
import './components/hero-carousel';
import './components/details-closer.js';
Alpine.start();

document.addEventListener('turbo:before-cache', function () {
  var cookieConsent = document.getElementById('CookieConsent');
  if (cookieConsent) {
    cookieConsent.remove();
  }
  document.querySelectorAll('details').forEach((d) => {
    d.removeAttribute('open');
  });
});
document.addEventListener('turbo:load', function () {
  const burgerClose = document.querySelector('figure.close') as HTMLElement;
  const mobileMenu = document.querySelector(
    '#burgerNavigationDetails',
  ) as HTMLDetailsElement;

  burgerClose.addEventListener('click', () => {
    mobileMenu.removeAttribute('open');
  });

  if (document.querySelector('#iframe-block')) {
    var iframe = document.createElement('iframe') as HTMLIFrameElement;
    iframe.src = document
      .querySelector('#iframe-block')
      .getAttribute('data-src');
    iframe.frameBorder = '0';
    document.querySelector('#iframe-block').appendChild(iframe);
  }

  if (document.querySelector('#location-page')) {
    initLocationPage();
  }

  if (document.querySelector('#employees-page')) {
    initEmployeesFilters();
  }

  if (document.querySelector('#kontakt-formular')) {
    document.querySelector('#kontakt-formular').scrollIntoView();
    }

    if (document.querySelector('#car-contact-form-dialog')) {
        var contactButton = document.querySelector('#car-contact-form-button') as HTMLButtonElement;
        var closeButton = document.querySelector('#car-modal-close') as HTMLButtonElement;
        var dialog = document.querySelector('#car-contact-form-dialog') as HTMLDialogElement;
        contactButton.addEventListener("click", () => {
            dialog.open = true;
        })
        closeButton.addEventListener("click", () => {
            dialog.open = false;
        })
    }

  const modalButtons = document.getElementsByClassName(
    'call-button',
  ) as HTMLCollectionOf<HTMLButtonElement>;
  for (let i = 0; i < modalButtons.length; i++) {
    modalButtons[i].addEventListener('click', () => {
      const locationId = modalButtons[i].getAttribute('data-location-id');
      const modal = document.getElementById(
        `phone-modal-${locationId}`,
      ) as HTMLDialogElement;
      modal.showModal();
    });
  }

  const closeModalButtons = document.getElementsByClassName(
    'close-modal-button',
  ) as HTMLCollectionOf<HTMLButtonElement>;
  for (let i = 0; i < closeModalButtons.length; i++) {
    closeModalButtons[i].addEventListener('click', () => {
      const locationId = modalButtons[i].getAttribute('data-location-id');
      const modal = document.getElementById(
        `phone-modal-${locationId}`,
      ) as HTMLDialogElement;

      modal.close();
    });
  }
});
